<template>
  <div class="blessing-bag" :style="bgStyle">
    <div class="blessing-bag-wrap" :class="'grid-' + blessingBag.num">
      <div v-for="(item, index) in blessingBag.list" :key="index">
        <div class="flex justify-center" @click="onClick(item, index)">
          <blessing-bag-item :item="item" />
        </div>
      </div>
    </div>
    <template v-if="psText">
      <div class="relative z-10 mt-4 text-small text-theme-black-250 text-right">
        <span v-if="psIcon">
          <i class="iconfont" :class="psIcon"></i>
        </span>
        {{psText}}
      </div>
    </template>
  </div>
</template>

<script>
import BlessingBagItem from './BlessingBagItem'

export default {
  name: 'BlessingBag',
  components: { BlessingBagItem },
  props: {
    blessingBag: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onClick(item) {
      this.$emit('click', item)
    }
  },
  computed:{
    psIcon(){
      const blessingConfig = this.$bus.survey.otherSetting.blessingConfig || {}
      if (!blessingConfig.imageRemarkIcon) return null
      return blessingConfig.imageRemarkIcon
    },
    psText(){
      const blessingConfig = this.$bus.survey.otherSetting.blessingConfig || {}
      if (!blessingConfig.imageRemark) return null
      return blessingConfig.imageRemark
    },
    bgStyle(){
      const blessingConfig = this.$bus.survey.otherSetting.blessingConfig || {}
      return {
        'background-size': blessingConfig.size || 'cover'
      }
    }
  }
}
</script>

<style scoped>
.blessing-bag {
  background-image: url(./assets/blessing-bag-bg.png);
  background-repeat: no-repeat;
  border-radius: 8px;
  padding: 15% 16px 20px;
  position: relative;

  &::after {
    content: " ";
    position: absolute;
    top: 100px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(252, 233, 230,1);
    border-radius: 8px;
  }
}

.blessing-bag-wrap {
  display: grid;
  grid-row-gap: 8px;
  position: relative;
  z-index: 10;
}

.grid-4 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-3,
.grid-6,
.grid-9 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-12 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
</style>
